import {Component, OnInit, Pipe, ViewChild} from '@angular/core';
import {SurveyResearchHeaderModel} from '../../../models/survey-research-header.model';
import {DxDataGridComponent} from 'devextreme-angular';
import {TranslateModel} from '../../../../core/_base/layout/models/translate.model';
import {LanguageTranslatePopup} from '../../../component/popup/language-translate/language-translate.popup';
import {TranslationService} from '../../../../provider/translation.service';
import {MatDialog} from '@angular/material';
import {SurveyHeaderService} from '../../../../provider/survey-header.service';
import {AWSService} from '../../../../provider/aws.service';
import {Router} from '@angular/router';
import {MenuAsideService} from '../../../../core/_base/layout';

@Component({
  selector: 'kt-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent implements OnInit {
  notificationResult = false;
  segmentations = JSON.parse(localStorage.getItem("segmentations")) || []
  notificationResultData: SurveyResearchHeaderModel = new SurveyResearchHeaderModel();

  constructor(public tra: TranslationService,
              public dialog: MatDialog,
              public surveyHeader: SurveyHeaderService,
              public awsService: AWSService,
              public router: Router,
              private menuAsideService: MenuAsideService) {

    this.menuAsideService.pathname$.next(window.location.pathname);
    this.hotelId = +JSON.parse(localStorage.getItem('token_form')).app_hotel_id;

  }

  imageUrl = '';
  currentSurvey: SurveyResearchHeaderModel = new SurveyResearchHeaderModel();
  hotelId: number;
  dataSource: SurveyResearchHeaderModel = new SurveyResearchHeaderModel();
  survey_title = '';

  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent;
  popupVisible = false;
  loading = false;
  point: number;

  // getAvgPoint(id: number): number {
  //   console.log(id);
  //   this.surveyHeader.getSurveyResult('surveyId', id).subscribe((point) => {
  //     this.point = point;
  //   });
  //   console.log(this.point);
  //   return this.point;
  // }


  ngOnInit() {
    this.surveyHeader.getSurveyHeader(+JSON.parse(localStorage.getItem('token_form')).app_hotel_id);
    this.dataSource.type = 'survey';
  }

  send() {
    this.dataSource.hotel_id = this.hotelId;
    this.surveyHeader.postSurveyHeader(this.dataSource);
    this.dataSource = new SurveyResearchHeaderModel();
    this.imageUrl = '';
  }

  imgUploadClickLogo(elementID: string) {
    document.getElementById(elementID).click();
  }

  uploadFileLogo(event: any, directory: string) {
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.awsService.uploadImage(file, this.hotelId, directory, file.name).subscribe(
            (resp: any) => {
              console.log(resp);
              this.dataSource.image_url = resp.link;
              this.imageUrl = resp.link;
              this.surveyHeader.getSurveyImage(this.hotelId, directory);
            }
          );
        };
      }
    }
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'Marketing') {
      this.currentSurvey = baseData;
    } else {
      this.currentSurvey = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      // this.surveyHeader.postSurveyHeader(this.dataSource);
      if (this.currentSurvey != undefined) {
        // this.surveyHeader.postSurveyHeader(this.currentSurvey);
      }
    });

  }

  showResult(id, title) {
    this.survey_title = title;
    this.surveyHeader.GETChartResult('surveyId', id);
    this.surveyHeader.GETChartDateAvg('surveyId', id);
    this.loading = true;
    this.popupVisible = true;
    this.surveyHeader.GETResultResearchWithProfiles('surveyId', id);
  }

  showNotificationResult(surveyHeaderID) {
    this.notificationResult = true;
    this.surveyHeader.getNotificationResult(surveyHeaderID);
  }


  changeStatus(data) {
    if (data.status == false) {
      data.status = 0;
    } else if (data.status == true) {
      data.status = 1;
    }
    console.log(data);
    this.surveyHeader.postSurveyHeader(data);
  }

}
